// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
// import JsPDF from 'jspdf'

export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function () {
      let title = this.htmlTitle || '成绩报告'
      let dom = this.domString || 'pdfDom'
      html2Canvas(document.querySelector(`#${dom}`), {
        allowTaint: true,
        useCORS: true
      }).then(function (canvas) {
        canvas.toBlob(function (blob) {
          var a = document.createElement('a')
          // var body = document.getElementsByTagName('body')
          document.body.appendChild(a)
          a.download = title + '.jpg'
          a.href = window.URL.createObjectURL(blob)
          a.click()
          document.body.removeChild(a)
        })
      }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/utils/htmlToPdf.js